import { GetKCloudIntegrationApi } from "@/features/accounts/account-group/services/get-kcloud-integration-api";
import { GetKCloudIntegrationRequestModel } from "@/features/accounts/account-group/services/get-kcloud-integration-model";

/// サービス連携情報取得
export class GetKCloudIntegrationService {
  private getKCloudIntegrationApi = new GetKCloudIntegrationApi();

  /**
   * サービス連携情報取得
   */
  public async getKCloudIntegration(param: GetKCloudIntegrationRequestModel) {
    return await this.getKCloudIntegrationApi.getKCloudIntegration(param);
  }
}
